import styles from './Hero.module.css'

import Arg from './Arg/Arg'

const Hero = () => {

	const args = [
		{
			title: 'Who We Are',
			body: `FiscalNote combines the latest AI technology with decades of trusted expertise to simplify 
			the way organizations track and shape policy. Our clients include organizations of all sizes 
			from half of the Fortune 100 to advocacy groups and government agencies.
`,
			img: 'who'
		},
		{
			title: 'Our Approach',
			body: `At FiscalNote, we empower the decisions that determine policy for future generations. 
			With our new prediction markets, we welcome the general public to engage with the process in a fun and 
			exciting way and offer three different ways to do so. 
`,
			img: 'what'
		},
		{
			title: 'Why Now',
			body: `We believe the convergence of prediction markets and fantasy sports-style participation is transforming 
			how people engage with political and policy outcomes, and we see an unmet need we’re uniquely positioned 
			to solve.`,
			img: 'why'
		},
	];

	const argsList = args.map((arg, index)=>{ return <Arg title={arg.title} body={arg.body} img={arg.img} index={index} key={index} />})

	return(
		<div class='row'>
			<div class='col-12 col-md-10 offset-md-1 py-5'>
				<h1 className={styles.Tagline}>Prediction Markets for Political & Policy Insights</h1>
				{argsList}
			</div>
		</div>
	)

}

export default Hero;
